import { useTaskCreate } from "@gymflow/api";
import { useClubSettings } from "apps/portal/src/providers";
import { ToastContext } from "apps/portal/src/providers/ToastProvider/context";
import useGymflowModels from "apps/portal/src/store";
import { useCallback, useContext } from "react";

import { normalizeOutgoingData } from "../utils/dataNormalizer";
import { TaskForm } from "./TaskForm/TaskForm";
import { TaskFormProps, TaskFormValues } from "./TaskForm/types";

type CreateTaskSidebarProps = Pick<TaskFormProps, "onClose" | "initialValues">;

export const CreateTaskForm = ({
  onClose,
  initialValues,
}: CreateTaskSidebarProps) => {
  const { api } = useGymflowModels();
  const { club } = useClubSettings();
  const { toast } = useContext(ToastContext);
  const { mutateAsync: mutateTaskCreate } = useTaskCreate({
    api,
    tz: club.timezone,
  });

  const onSubmit = useCallback(
    async (values: TaskFormValues) => {
      await mutateTaskCreate(normalizeOutgoingData(values));
      toast({ message: "Task Created" });
      onClose();
    },
    [mutateTaskCreate, toast, onClose],
  );

  return (
    <TaskForm
      initialValues={initialValues}
      title="Create Task"
      description="Assign tasks to owners and relate them to any user or lead."
      submitButtonText="Create Task"
      onClose={onClose}
      onSubmit={onSubmit}
    />
  );
};
